import { useCallback, useEffect, useRef } from 'react';

// class Highlighter {
//     private container: HTMLElement;
//     private tl: HTMLElement;
//     private br: HTMLElement;
//
//     constructor() {
//         this.container = document.createElement('div');
//         this.tl = document.createElement('div');
//         this.br = document.createElement('br');
//         this.container.append(this.tl, this.br);
//     }
//
//     set top(top: number) {
//         this.tl.style.setProperty('--width', top.toString());
//         this.br.style.setProperty('--width', top.toString());
//     }
//
//     set width(width: number) {
//
//     }
//
//     remove() {
//         this.container.remove();
//     }
// }

export const useElementHighlight = (element: HTMLElement|null): [show: () => void, hide: () => void] => {
    const highlightRef = useRef<HTMLElement|null>(null);

    const updateHighlight = useCallback(() => {
        const hl = highlightRef.current;
        if (element && hl) {
            const bb = element.getBoundingClientRect();
            hl.style.inset = '0';
            hl.style.top = `${bb.top - 5}px`;
            hl.style.left = `${bb.left - 5}px`;
            hl.style.width = `${bb.width + 10}px`;
            hl.style.height = `${bb.height + 10}px`;
            hl.style.background = 'transparent';
            hl.style.boxShadow = '0 0 0 5000px rgba(0, 0, 0, 0.6)';
            hl.style.position = 'fixed';
        }
    }, [ element ]);

    useEffect(() => {
        if (element) {
            if (!highlightRef.current) {
                highlightRef.current = document.createElement('div');
                highlightRef.current.style.display = 'none';
                document.body.append(highlightRef.current);
            }
            window.addEventListener('resize', updateHighlight);
            document.addEventListener('scroll', updateHighlight);
            updateHighlight();
        } else if (highlightRef.current) {
            highlightRef.current?.remove();
        }

        return () => {
            window.removeEventListener('resize', updateHighlight);
            document.removeEventListener('scroll', updateHighlight);
        };
    }, [ element, updateHighlight ]);

    const show = useCallback(() => {
        const hl = highlightRef.current;
        if (hl) {
            hl.style.display = 'block';
        }
    }, []);

    const hide = useCallback(() => {
        const hl = highlightRef.current;
        if (hl) {
            hl.style.display = 'none';
        }
    }, []);

    return [ show, hide ];
};
